module.exports = __webpack_public_path__ + "img/dispose8.f63c6dc7.png";